/** Angular core dependencies */
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ComponentsModule } from '@shared/components';

/** Custom Containers */
import { LayoutComponent } from './layout/layout.component';

/** Custom Containers Registration */
const CONTAINERS = [LayoutComponent];

@NgModule({
  imports: [
    /** Angular core dependencies */
    CommonModule,
    ComponentsModule
  ],
  declarations: CONTAINERS,
  exports: CONTAINERS,
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})
export class ContainersModule { }
